/** Ползунок выбора числового значения из диапазона. */
import type { ComponentPropsWithoutRef } from "react";

type RangeInputProps = Omit<ComponentPropsWithoutRef<"input">, "type" | "value" | "onChange"> & {
	value: number;
	min: number;
	max: number;
	step?: number;
	onChange: (value: number) => void;
};

export const RangeInput = ({
	value,
	min,
	max,
	step = 1,
	onChange,
	className = "h-1.5 w-full cursor-pointer accent-accent",
	...props
}: RangeInputProps) => (
	<input
		type="range"
		value={value}
		min={min}
		max={max}
		step={step}
		onChange={(event) => onChange(Number(event.target.value))}
		className={className}
		{...props}
	/>
);
